import { useNavigate as useNativeNavigate, useSearchParams } from 'react-router-dom';
import { useEventCallback } from 'usehooks-ts';
export { useParams, useSearchParams } from 'react-router-dom';

const keepQueryParameters = ['invitation_key', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

export const filterUtmParams = (
  paramsEntries: IterableIterator<[string, string]> | never[]
) => {
  return Array.from(paramsEntries).filter(([key]) =>
    keepQueryParameters.includes(key)
  );
};

function getNextUrl(searchParams: URLSearchParams, href: string) {
  // HACK: If relative URL given, stick the current host on the string passed to URL()
  // as the constructor throws an error if URL without a host is given
  const querySubstring = href.indexOf('?');
  const urlSearchParams = new URLSearchParams(
    querySubstring > -1 ? href.slice(querySubstring) : ''
  );
  
  const entries = searchParams ? searchParams.entries() : [];
  for (const [key, value] of filterUtmParams(entries)) {
    if (!urlSearchParams.has(key)) {
      urlSearchParams.set(key, value);
    }
  }

  const searchString = urlSearchParams.size
    ? '?' + urlSearchParams.toString()
    : '';

  return querySubstring > -1
    ? `${href.slice(0, querySubstring)}${searchString}`
    : href + searchString;
}

export const useNavigate = (): ReturnType<typeof useNativeNavigate> => {
  const navigate = useNativeNavigate();
  const [searchParams] = useSearchParams();

  return useEventCallback((to, options) => {
    const newTo = typeof to === 'string' ? getNextUrl(new URLSearchParams(searchParams), to) : to;
    return navigate(newTo, options);
  });
};
